import { Trans, useTranslation } from 'react-i18next';

import { GOSUSLUGI, StyledTooltipLink } from '@shared/index';

export const SnilsTooltipText = () => {
  const { t } = useTranslation();

  return (
    <StyledTooltipLink>
      <Trans
        values={{ href: GOSUSLUGI }}
        components={{ a: <a /> }}
      >
        {t('PERSONAL_DOCUMENTS:tooltips.snils-gosuslugi')}
      </Trans>
    </StyledTooltipLink>
  );
};
